<template>
  <div class="info-box">
    <div class="rider-detail">
      <div>
        <img class="url" :src="rider.profilePicture" />
      </div>
      <div class="info">
        <span class="name">{{ rider.name }} 파트너</span>
        <span class="phone-number">({{ rider.phoneNumber }})</span>
      </div>
    </div>
    <div class="location-detail">
      <div class="date">
        {{ $utcToLocal(updatedAt, "YY-MM-DD hh:mm") }} 기준
      </div>
      <img
        @click="$emit('refresh')"
        :class="{ spin: refreshing }"
        src="@/assets/img/order/cached_black.svg"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["rider", "updatedAt", "refreshing"]
};
</script>
<style scoped>
.info-box {
  background-color: var(--white);
  padding: 8px 8px;
  box-shadow: 0px 16px 32px 0px rgba(27, 57, 92, 0.12),
    0px 4px 12px -4px rgba(63, 83, 107, 0.08);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  width: fit-content;
}

.rider-detail {
  display: flex;
  align-items: center;
  gap: 8px;
}
.location-detail {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  align-items: center;
}

.info {
  display: flex;
  align-items: center;
  gap: 4px;
}
.name {
  color: var(--gray-700);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.phone-number {
  color: var(--gray-600);
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
}

.url {
  width: 32px;
  height: 32px;
  border-radius: 99px;
}

.date {
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
  color: var(--gray-600);
}

.location-detail img {
  cursor: pointer;
  width: 24px;
  height: 24px;
}

.spin {
  animation: fa-spin 2s infinite linear;
}

@media all and (min-width: 1024px) {
  .info-box {
    min-width: 440px;
    padding: 8px 16px;
    flex-direction: row;
    justify-content: space-between;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(1turn);
  }
}
</style>
